"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "textPairingVariants", {
    enumerable: true,
    get: function() {
        return textPairingVariants;
    }
});
var textPairingVariants = [
    "textpairing-header-4XL",
    "textpairing-header-3XL",
    "textpairing-header-2XL",
    "textpairing-header-XL",
    "textpairing-header-L",
    "textpairing-header-M",
    "textpairing-body-display-2XL",
    "textpairing-body-display-XL",
    "textpairing-body-display-L",
    "textpairing-body-display-M",
    "textpairing-body-display-S",
    "textpairing-body-bold",
    "textpairing-body-medium",
    "textpairing-body-bold-meta",
    "textpairing-body-medium-meta",
    "textpairing-body-regular-meta",
    "textpairing-body-meta-bold",
    "textpairing-body-meta-medium"
];
